<style src="./styles/global.scss" lang="scss"></style>
<template>
  <div id="app" :class="{'menu-opened': menuOpened}">
    <div class="menu">
      <router-link class="menu-item home" to="/">Home</router-link>
      <router-link class="menu-item" to="/schedule"><label>Schedule</label></router-link>
      <router-link class="menu-item" to="/checkout"><label>RSVP</label></router-link>
      <router-link class="menu-item" to="/speakers"><label>Speakers</label></router-link>
      <router-link class="menu-item" to="/latest"><label>Latest News</label></router-link>
      <router-link class="menu-item" to="/partners"><label>Partners</label></router-link>
      <router-link class="menu-item" to="/contact"><label>Contact Us</label></router-link>
    </div>
    <div class="content">
      <site-header :toggle-menu="toggleMenu" />
      <div class="content">
        <router-view/>
      </div>
      <site-footer />
    </div>
  </div>
</template>
<script>
  import SiteHeader from '@/components/SiteHeader.vue'
  import SiteFooter from '@/components/SiteFooter.vue'

  export default {
    name: 'app',
    components: { SiteHeader, SiteFooter },
    data() {
      return {
        menuOpened: false,
      }
    },
    computed: {
    },
    created() {
      window.addEventListener('click', this.closeMenu)
      this.$router.afterEach(() => {
        window.scrollTo(0, 0)
      })
    },
    mounted() {
    },
    destroyed() {
      window.removeEventListener('click', this.closeMenu)
    },
    methods: {
      toggleMenu() {
        this.menuOpened = !this.menuOpened;
      },
      closeMenu() {
        this.menuOpened = false;
      },
    },
  }
</script>
<style lang="scss" scoped>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $ink;
    padding-top: 40px;
    >.menu {
      display: none;
    }
  }
  @media (max-width: 500px) {
    #app {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      padding-top: 0;
      >.content {
        transition: all 0.2s ease;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
      >.menu {
        display: block;
        z-index: 1000;
        transition: all 0.2s ease;
        position: absolute;
        top: 60px;
        bottom: 0;
        left: -285px;
        width: 285px;
        .menu-item {
          display: block;
          color: $color-2;
          text-decoration: none;
          padding: 10px 0;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 1px;
          font-weight: bold;
          &.home {
            color: $color-1;
          }
          &.pillars {
            color: $color-4;
          }
        }
      }
      &.menu-opened {
        overflow: hidden;
        >.menu {
          left: 15px;
        }
        >.content {
          left: 300px;
          right: -300px;
          overflow: hidden;
        }
      }
    }
  }

</style>
